import { render, staticRenderFns } from "./merchant-product.vue?vue&type=template&id=7b17b213&scoped=true"
import script from "./merchant-product.vue?vue&type=script&lang=js"
export * from "./merchant-product.vue?vue&type=script&lang=js"
import style0 from "./merchant-product.vue?vue&type=style&index=0&id=7b17b213&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b17b213",
  null
  
)

export default component.exports